import { Component } from 'react'
import { RefreshCw, AlertTriangle } from 'lucide-react'
import * as Sentry from '@sentry/react'

export default class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info)
    Sentry.captureException(error, { extra: info })
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-bg flex items-center justify-center p-6">
          <div className="max-w-sm w-full text-center">
            <div className="w-14 h-14 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle size={28} className="text-red-400" />
            </div>
            <h2 className="font-display text-2xl mb-2">Something went wrong</h2>
            <p className="text-sm text-gray-500 mb-6">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <button
              onClick={() => { this.setState({ error: null }); window.location.reload() }}
              className="flex items-center gap-2 px-5 py-2.5 bg-accent text-bg font-bold rounded-xl text-sm hover:bg-accent3 transition-all mx-auto"
            >
              <RefreshCw size={14} /> Reload App
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
